module.exports = __webpack_public_path__ + "static/media/mobileBlueoutline.8f238910.svg";